import { useEffect, useState } from 'react'
import { KeycloakAdminService, KeycloakService } from '@nv/auth'
import { AdminVoterService, VoterAuthService } from '@nv/services'

export const useGetEvent = (eventId) => {
  const [event, setEvent]: any = useState()
  useEffect(() => {
    const getAdminEvent = async () => {
      const resp = await AdminVoterService.getEvent(eventId)
      if (resp?.event) {
        setEvent(resp.event)
      }
    }
    const getVoterEvent = async () => {
      const resp = await VoterAuthService.getEventById(eventId)
      if (resp) setEvent(resp)
    }
    if (eventId) {
      if (KeycloakAdminService.isLoggedIn()) {
        getAdminEvent()
      } else if (KeycloakService.isLoggedIn()) {
        // For voter portal
        getVoterEvent()
      }
    }
  }, [KeycloakAdminService.isLoggedIn(), KeycloakService.isLoggedIn(), eventId])

  return event
}
